import 'gumshoejs/dist/gumshoe.polyfills';

import $ from 'gridstrap/lib/gs-zepto';
import Gumshoe = require('gumshoejs/dist/gumshoe');


export class GSMarkdownTOC {
	private document;
	private gumshoe;

	constructor(root) {
		this.document = $(document);

		this.gumshoe = new Gumshoe('.gs-MarkdownTOC a', {
			navClass: 'is-active',
			offset: 100,
			events: true,
			reflow: true
		});
	}

	gsOnInit() {
		this.document.on('gumshoeActivate', (event) => {
			const link = $(event.target);
			const section = link.closest('.gs-MarkdownTOC-section');
			section.addClass('is-expanded');
		});

		this.document.on('gumshoeDeactivate', (event) => {
			const link = $(event.target);
			const section = link.closest('.gs-MarkdownTOC-section');
			section.removeClass('is-expanded');
		});
	}

	gsOnDestroy() {
		this.document.off('gumshoeActivate');
		this.document.off('gumshoeDeactivate');
		this.gumshoe.destroy();
	}
}
